import { IBaseWidget, IWidgetDirectiveType } from '@framework/engine';
import {
  IIntegrableDirective,
  IntegrableDirectiveSchema,
} from './IIntegrableDirective';
import { IntegrableDirectiveConfigComponent } from './IntegrableDirectiveConfigComponent';

export const INTEGRABLE_DIRECTIVE_KEY = 'directiveIntegrable';

export const IntegrableDirectiveType: IWidgetDirectiveType<IIntegrableDirective> =
  {
    name: 'integrable',
    key: 'integrable',
    allowsWidget: (widget, widgetType) => widgetType.hasValue,
    configComponent: IntegrableDirectiveConfigComponent,
    configSchema: IntegrableDirectiveSchema,
    formSchemaModifier: ({
      directiveConfig,
      schema,
      widget,
      widgetType,
      flags,
    }) => {
      // Se è abilitata (non è disabilitata) la modifica in fase di integrazione, ritorniamo lo schema
      return schema.meta?.({
        [INTEGRABLE_DIRECTIVE_KEY]: !directiveConfig.disabled,
      });
    },
  };

/**
 * Utility che ritorna vero quando il widget è integrabile.
 * (ovvero quando, all'interno di un'integrazione, è permesso all'utente
 * modificare il widget)
 */
export function isWidgetIntegrable(widget: IBaseWidget): boolean {
  return !widget.directives?.[IntegrableDirectiveType.key]?.disabled;
}
